<!--
<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Person und Konto</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="accountForm">

                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Rolle:</mat-label>
                                <mat-select formControlName="role">
                                    <mat-option *ngFor="let sortOption of roles" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="accountForm.get('role').hasError('required')">
                                    Rolle <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Kundenummer:</mat-label>
                                <input matInput type="text" formControlName="customerNumber">

                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Nutzername:</mat-label>
                                <input matInput type="email" formControlName="username">
                                <mat-error *ngIf="accountForm.get('username').hasError('required')">
                                    Nutzername <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Telefon:</mat-label>
                                <input matInput type="text" formControlName="phone">

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Anrede:</mat-label>
                                <mat-select formControlName="gender">
                                    <mat-option *ngFor="let sortOption of genderOptions" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                    Anrede <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Titel:</mat-label>
                                <input matInput type="text" formControlName="title">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="text" formControlName="firstName">
                                <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="text" formControlName="lastName">
                                <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                    Nachname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Geburtstag:</mat-label>
                                <input matInput type="date" formControlName="birthday">
                                <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                    Geburtstag <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                             <mat-form-field class="full-width" >
                                <mat-label>Telefonnummer:</mat-label>
                                <input matInput type="number" formControlName="phone">
                                <mat-error *ngIf="accountForm.get('phone').hasError('required')">
                                    Telefonnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Im Portal seit: </mat-label>
                                <input matInput type="date" formControlName="created">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Letzte Änderung am: </mat-label>
                                <input matInput type="date" formControlName="lastModified">
                            </mat-form-field>
                        </div>
                    </div>



                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()" >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>

    </div>

    <div class="row marginTop2Rem marginBottom2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Anschrift</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width" >
                                <mat-label>Straße + Hausnummer:</mat-label>
                                <input matInput type="text" formControlName="street">
                                <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                    Straße + Hausnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>PLZ:</mat-label>
                                <input matInput type="text" formControlName="postcode">
                                <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                    PLZ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                                <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                    Ort <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()" >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div> -->

<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Person und Konto</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="accountForm">

                    <div class="row" [formGroup]="accountForm">

                        
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nutzername:</mat-label>
                                <input matInput type="text" formControlName="username">
                                <mat-error *ngIf="accountForm.get('username').hasError('required')">
                                    Nutzername <strong>muss</strong> angegeben werden
                                </mat-error>
                                <!-- <mat-error *ngIf="accountForm.get('username').hasError('email')">
                                    E-Mail <strong>muss</strong> ein gültiges Format haben
                                </mat-error> -->
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Kundenummer:</mat-label>
                                <input matInput type="text" formControlName="customerNumber">

                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Rolle:</mat-label>
                                <mat-select formControlName="role">
                                    <mat-option *ngFor="let sortOption of roles" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="accountForm.get('role').hasError('required')">
                                    Rolle <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Anrede:</mat-label>
                                <mat-select formControlName="gender">
                                    <mat-option *ngFor="let sortOption of genderOptions" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                    Anrede <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Titel:</mat-label>
                                <input matInput type="text" formControlName="title">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Geburtstag:</mat-label>
                                <input matInput type="date" formControlName="birthday">
                                <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                    Geburtstag <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="text" formControlName="firstName">
                                <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="text" formControlName="lastName">
                                <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                    Nachname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

      

                      <div class="col-sm-6">
                        <mat-form-field class="full-width" >
                            <mat-label>E-Mail:</mat-label>
                            <input matInput type="mail" formControlName="email">
                            <mat-error *ngIf="accountForm.get('email').hasError('required')">
                                E-Mail <strong>muss</strong> angegeben werden
                            </mat-error>
                        </mat-form-field> 
                    </div>


                      <div class="col-sm-6">
                            <mat-form-field class="full-width" >
                                <mat-label>Telefonnummer:</mat-label>
                                <input matInput type="number" formControlName="phone">
                                <mat-error *ngIf="accountForm.get('phone').hasError('required')">
                                    Telefonnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field> 
                        </div>


                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Im Portal seit: </mat-label>
                                <input matInput type="date" formControlName="created">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Letzte Änderung am: </mat-label>
                                <input matInput type="date" formControlName="lastModified">
                            </mat-form-field>
                        </div>
                    </div>
<!-- 
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-checkbox [(ngModel)]="this.deactivateNever" [ngModelOptions]="{standalone: true}"
                                (change)="changeNeverDeactivate($event)">
                                Nie sperren
                            </mat-checkbox>
                        </div>
                    </div> -->
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>

    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Anschrift</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Straße + Hausnummer:</mat-label>
                                <input matInput type="text" formControlName="street">
                                <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                    Straße + Hausnummer <strong>muss</strong> angegeben werden
                                </mat-error>
                                <mat-hint *ngIf="!this.isHead">
                                    Die Adresse kann bei Haushaltsmitgliedern nicht bearbeitet werden.
                                </mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>PLZ:</mat-label>
                                <input matInput type="text" formControlName="postcode">
                                <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                    PLZ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                                <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                    Ort <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>


    <!-- <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>
                        Weitere Kontakte
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="contactForm">
                    <div class="row ">
                        <ng-container *ngFor="let lessonForm of contactChannels.controls; let i = index">
                            <div class="row " [formGroup]="lessonForm">
                                <div class="col-sm-3">
                                    <mat-form-field class="full-width">
                                        <mat-label>Typ:</mat-label>
                                        <mat-select formControlName="channelType" [disabled]="true">
                                            <mat-option *ngFor="let sortOption of contactChannelOptions"
                                                [value]="sortOption.value" [disabled]="sortOption.state">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>
                                            Typ <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-5">
                                    <mat-form-field class="full-width">
                                        <mat-label>Adresse:</mat-label>
                                        <input matInput formControlName="channelData">
                                        <mat-error>
                                            Adresse <strong>muss</strong> angegeben werden
                                        </mat-error>

                                    </mat-form-field>

                                </div>
                                <div class="col-sm-3">
                                    <mat-form-field class="full-width">
                                        <mat-label>Status:</mat-label>
                                        <mat-select formControlName="channelState">
                                            <mat-option *ngFor="let sortOption of contactChannelTypes"
                                                [value]="sortOption.value" [disabled]="sortOption.state">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-1 ">
                                    <button mat-icon-button style="margin: 0 auto !important;"
                                        [matMenuTriggerFor]="menu" color="accent">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="deletContactChannels(i)"
                                            [disabled]="lessonForm.getRawValue().channelType == 'EMAIL'">
                                            Löschen
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <button mat-raised-button color="accent" (click)="addContactChannels()">
                        Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                    </button>
                </mat-card-content>
                <mat-card-actions align="end" *ngIf="contactFormChanged">

                    <button mat-button color="primary" (click)="editContactChannels()">Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div> -->
</div>

<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>